
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1 className="text-xl font-bold text-gray-800" style={{ fontFamily: '"Pacifico", serif' }}>
              Saori Ando
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => scrollToSection('works')}
              className="text-gray-700 hover:text-pink-600 transition-colors"
            >
              実績
            </button>
            <button 
              onClick={() => scrollToSection('profile')}
              className="text-gray-700 hover:text-pink-600 transition-colors"
            >
              プロフィール
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-pink-600 transition-colors"
            >
              サービス内容
            </button>
          </nav>

          {/* Contact Button */}
          <div className="hidden md:block">
            <Button 
              size="sm"
              onClick={() => scrollToSection('contact')}
            >
              お問い合わせ
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-pink-600 transition-colors"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('works')}
                className="text-left text-gray-700 hover:text-pink-600 transition-colors"
              >
                実績
              </button>
              <button 
                onClick={() => scrollToSection('profile')}
                className="text-left text-gray-700 hover:text-pink-600 transition-colors"
              >
                プロフィール
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-left text-gray-700 hover:text-pink-600 transition-colors"
              >
                サービス内容
              </button>
              <Button 
                size="sm"
                onClick={() => scrollToSection('contact')}
                className="w-full"
              >
                お問い合わせ
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
